import type { Component } from "vue";
import {
  ArrowDown,
  ArrowLeft,
  ArrowLeftRight,
  ArrowRight,
  ArrowUp,
  ArrowUpDown,
  Baby,
  Ban,
  Banknote,
  Barcode,
  Bell,
  Bold,
  BookOpen,
  Box,
  Boxes,
  Building,
  Building2,
  Calculator,
  Calendar,
  CalendarCheck,
  CalendarPlus,
  CalendarRange,
  CalendarX,
  ChartArea,
  ChartBar,
  Check,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronUp,
  Circle,
  CircleAlert,
  CircleCheck,
  CircleQuestionMark,
  CircleUser,
  CircleX,
  ClipboardList,
  ClipboardPaste,
  ClipboardPlus,
  Clock,
  Coins,
  ConciergeBell,
  Copy,
  CreditCard,
  Crop,
  CircleDollarSign,
  Download,
  Ellipsis,
  Eraser,
  Eye,
  EyeOff,
  Factory,
  File,
  FileDown,
  FileImage,
  FileInput,
  FileOutput,
  FilePen,
  FilePlus,
  FileSpreadsheet,
  FileText,
  FileUp,
  FlaskConical,
  FlaskRound,
  Funnel,
  Gauge,
  GraduationCap,
  HandCoins,
  HandHeart,
  History,
  IdCard,
  Image,
  Inbox,
  Infinity as InfinityIcon,
  Info,
  Italic,
  KeyRound,
  LifeBuoy,
  Link,
  List,
  ListChecks,
  ListOrdered,
  LoaderCircle,
  Lock,
  LockOpen,
  LogIn,
  LogOut,
  Mail,
  MapPin,
  MemoryStick,
  Menu,
  MessageCircle,
  MessageSquare,
  Minus,
  MousePointer,
  Paperclip,
  Pencil,
  Phone,
  PiggyBank,
  Pizza,
  Play,
  Plug,
  Plus,
  Printer,
  Receipt,
  Recycle,
  Redo2,
  RefreshCw,
  RemoveFormatting,
  Reply,
  RotateCcw,
  Route,
  Save,
  Scale,
  Search,
  SearchCheck,
  Send,
  Settings,
  ShieldUser,
  ShoppingBag,
  ShoppingCart,
  SlidersHorizontal,
  SquareCheck,
  SquareX,
  StickyNote,
  Strikethrough,
  Tag,
  Tags,
  TextAlignStart,
  Trash2,
  TriangleAlert,
  Truck,
  Underline,
  Undo2,
  Unlink,
  Upload,
  User,
  UserCheck,
  UserPlus,
  UserRound,
  Users,
  Utensils,
  Wallet,
  Warehouse,
  Weight,
  Wifi,
  X,
  ZoomOut,
} from "lucide-vue-next";

const FA_TO_LUCIDE: Record<string, Component> = {
  "fa-address-card": IdCard,
  "fa-align-left": TextAlignStart,
  "fa-allergies": HandHeart,
  "fa-arrow-down": ArrowDown,
  "fa-arrow-left": ArrowLeft,
  "fa-arrow-right": ArrowRight,
  "fa-arrow-up": ArrowUp,
  "fa-at": Mail,
  "fa-balance-scale": Scale,
  "fa-balance-scale-right": Scale,
  "fa-ban": Ban,
  "fa-barcode": Barcode,
  "fa-bars": Menu,
  "fa-bell": Bell,
  "fa-bold": Bold,
  "fa-book": BookOpen,
  "fa-book-open": BookOpen,
  "fa-boxes": Boxes,
  "fa-building": Building,
  "fa-calculator": Calculator,
  "fa-calendar": Calendar,
  "fa-calendar-alt": Calendar,
  "fa-calendar-check": CalendarCheck,
  "fa-calendar-plus": CalendarPlus,
  "fa-calendar-times": CalendarX,
  "fa-calendar-week": CalendarRange,
  "fa-chart-area": ChartArea,
  "fa-chart-bar": ChartBar,
  "fa-check": Check,
  "fa-check-circle": CircleCheck,
  "fa-check-square": SquareCheck,
  "fa-chevron-down": ChevronDown,
  "fa-chevron-left": ChevronLeft,
  "fa-chevron-right": ChevronRight,
  "fa-chevron-up": ChevronUp,
  "fa-child": Baby,
  "fa-circle": Circle,
  "fa-city": Building2,
  "fa-clipboard-list": ClipboardList,
  "fa-clock": Clock,
  "fa-cog": Settings,
  "fa-cogs": Settings,
  "fa-coins": Coins,
  "fa-comment": MessageCircle,
  "fa-comment-alt": MessageSquare,
  "fa-concierge-bell": ConciergeBell,
  "fa-copy": Copy,
  "fa-credit-card": CreditCard,
  "fa-crop": Crop,
  "fa-cube": Box,
  "fa-cubes": Boxes,
  "fa-dollar-sign": CircleDollarSign,
  "fa-download": Download,
  "fa-edit": Pencil,
  "fa-ellipsis-h": Ellipsis,
  "fa-envelope": Mail,
  "fa-eraser": Eraser,
  "fa-exclamation": Info,
  "fa-exclamation-circle": CircleAlert,
  "fa-exclamation-triangle": TriangleAlert,
  "fa-eye": Eye,
  "fa-eye-slash": EyeOff,
  "fa-file": File,
  "fa-file-contract": FilePen,
  "fa-file-csv": FileSpreadsheet,
  "fa-file-download": FileDown,
  "fa-file-excel": FileSpreadsheet,
  "fa-file-export": FileOutput,
  "fa-file-image": FileImage,
  "fa-file-import": FileInput,
  "fa-file-invoice": FileText,
  "fa-file-invoice-dollar": FileText,
  "fa-file-medical": FilePlus,
  "fa-file-pdf": FileText,
  "fa-file-upload": FileUp,
  "fa-file-word": FileText,
  "fa-filter": Funnel,
  "fa-flask": FlaskConical,
  "fa-graduation-cap": GraduationCap,
  "fa-hand-holding-usd": HandCoins,
  "fa-history": History,
  "fa-id-badge": IdCard,
  "fa-id-card": IdCard,
  "fa-image": Image,
  "fa-inbox": Inbox,
  "fa-industry": Factory,
  "fa-infinity": InfinityIcon,
  "fa-info": Info,
  "fa-info-circle": Info,
  "fa-italic": Italic,
  "fa-key": KeyRound,
  "fa-life-ring": LifeBuoy,
  "fa-link": Link,
  "fa-list": List,
  "fa-list-alt": ListChecks,
  "fa-list-ol": ListOrdered,
  "fa-list-ul": List,
  "fa-lock": Lock,
  "fa-map-marker": MapPin,
  "fa-map-marker-alt": MapPin,
  "fa-minus": Minus,
  "fa-money-bill": Banknote,
  "fa-money-bill-wave": Banknote,
  "fa-mortar-pestle": FlaskRound,
  "fa-mouse-pointer": MousePointer,
  "fa-notes-medical": ClipboardPlus,
  "fa-paper-plane": Send,
  "fa-paperclip": Paperclip,
  "fa-paste": ClipboardPaste,
  "fa-pen": Pencil,
  "fa-pencil-alt": Pencil,
  "fa-phone": Phone,
  "fa-phone-alt": Phone,
  "fa-piggy-bank": PiggyBank,
  "fa-pizza-slice": Pizza,
  "fa-play": Play,
  "fa-plug": Plug,
  "fa-plus": Plus,
  "fa-print": Printer,
  "fa-question": CircleQuestionMark,
  "fa-question-circle": CircleQuestionMark,
  "fa-receipt": Receipt,
  "fa-recycle": Recycle,
  "fa-redo": Redo2,
  "fa-refresh": RefreshCw,
  "fa-remove-format": RemoveFormatting,
  "fa-reply": Reply,
  "fa-right-left": ArrowLeftRight,
  "fa-rotate-left": RotateCcw,
  "fa-route": Route,
  "fa-save": Save,
  "fa-sd-card": MemoryStick,
  "fa-search": Search,
  "fa-search-dollar": SearchCheck,
  "fa-search-minus": ZoomOut,
  "fa-shopping-bag": ShoppingBag,
  "fa-shopping-cart": ShoppingCart,
  "fa-sign-in-alt": LogIn,
  "fa-sign-out-alt": LogOut,
  "fa-sliders-h": SlidersHorizontal,
  "fa-sort": ArrowUpDown,
  "fa-sort-down": ArrowDown,
  "fa-sort-up": ArrowUp,
  "fa-spinner": LoaderCircle,
  "fa-sticky-note": StickyNote,
  "fa-strikethrough": Strikethrough,
  "fa-sync": RefreshCw,
  "fa-sync-alt": RefreshCw,
  "fa-tachometer-alt": Gauge,
  "fa-tag": Tag,
  "fa-tags": Tags,
  "fa-times": X,
  "fa-times-circle": CircleX,
  "fa-trash": Trash2,
  "fa-trash-alt": Trash2,
  "fa-truck": Truck,
  "fa-truck-loading": Truck,
  "fa-underline": Underline,
  "fa-undo": Undo2,
  "fa-university": Building2,
  "fa-unlink": Unlink,
  "fa-unlock": LockOpen,
  "fa-unlock-alt": LockOpen,
  "fa-upload": Upload,
  "fa-user": User,
  "fa-user-alt": User,
  "fa-user-check": UserCheck,
  "fa-user-circle": CircleUser,
  "fa-user-clock": UserRound,
  "fa-user-friends": Users,
  "fa-user-plus": UserPlus,
  "fa-user-shield": ShieldUser,
  "fa-user-tie": UserRound,
  "fa-users": Users,
  "fa-utensils": Utensils,
  "fa-wallet": Wallet,
  "fa-warehouse": Warehouse,
  "fa-weight": Weight,
  "fa-weight-hanging": Weight,
  "fa-wifi": Wifi,
  "fa-window-close": SquareX,
};

export const faIconName = (faClasses: string): string | null =>
  faClasses.split(/\s+/).find((className) => className in FA_TO_LUCIDE) ?? null;

export const lucideFromFa = (faClasses: string): Component | null => {
  const iconName = faClasses.split(/\s+/).find((className) => className in FA_TO_LUCIDE);

  return iconName ? FA_TO_LUCIDE[iconName] : null;
};
